import {
    IActivityEventResponse,
    IAnalyticsModelResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import { fetchFileFromApi } from 'utils/fetch';
import { downloadFile, FileType } from 'utils/file';
import { Filter } from 'utils/query_v3';

export const getFaultSeverity = (event: IActivityEventResponse | undefined) => {
    const rawSeverity = event?.Fields.find((field) => field.FieldCode === 'severity')
        ?.FieldValue;
    if (rawSeverity) {
        return Number(rawSeverity);
    }
    return 0;
};

export const getFaultRecommendation = (event: IActivityEventResponse) =>
    event.Fields.find((field) => field.FieldCode === 'recommendedmaintenance')
        ?.FieldValue ?? 'No action required';

export const getFaultName = (event: IActivityEventResponse) =>
    event.Fields.find((field) => field.FieldCode === 'faultname')?.FieldValue ??
    'unknown';

export const isModelAssignedToGroup = async (
    model: IAnalyticsModelResponse,
    groupId: string
): Promise<boolean> => {
    const results = await sdClient.getAnalyticsAssignments({
        filter: Filter.and(
            Filter.eq('AnalyticsModelId', model.Id),
            Filter.eq('RootGroupId', groupId)
        ),
        page: 1,
        pageLimit: 1,
    });
    return results.Total > 0;
};

export type IsModelUniqueOptions = Readonly<{
    name: string;
    version: string;
    corporationId?: string;
}>;

export const isModelUnique = async ({
    name,
    version,
    corporationId,
}: IsModelUniqueOptions) => {
    const existingModel = await sdClient.getAnalyticsModels({
        filter: Filter.and(
            corporationId ? Filter.eq('CorporationId', corporationId) : undefined,
            Filter.eq('Name', name.trim()),
            Filter.eq('Version', version.trim())
        ),
        page: 1,
        pageLimit: 1,
    });
    return existingModel.Total === 0;
};

export const downloadModelSourceCodeTemplate = async () => {
    const file = await fetchFileFromApi(
        `Analytics/Models/Source/Template`,
        `model-template.zip`,
        FileType.Zip,
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }
    );
    downloadFile(file);
};
